"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var i0 = require("./adv-user-messages.component.css.shim.ngstyle");
var i1 = require("@angular/core");
var i2 = require("./adv-user-messages.component");
var styles_AdvUserMessagesComponent = [i0.styles];
var RenderType_AdvUserMessagesComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_AdvUserMessagesComponent, data: {} });
exports.RenderType_AdvUserMessagesComponent = RenderType_AdvUserMessagesComponent;
function View_AdvUserMessagesComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "div", [["class", "container"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, [" Messages\n"]))], null, null); }
exports.View_AdvUserMessagesComponent_0 = View_AdvUserMessagesComponent_0;
function View_AdvUserMessagesComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-adv-user-messages", [], null, null, null, View_AdvUserMessagesComponent_0, RenderType_AdvUserMessagesComponent)), i1.ɵdid(1, 114688, null, 0, i2.AdvUserMessagesComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_AdvUserMessagesComponent_Host_0 = View_AdvUserMessagesComponent_Host_0;
var AdvUserMessagesComponentNgFactory = i1.ɵccf("app-adv-user-messages", i2.AdvUserMessagesComponent, View_AdvUserMessagesComponent_Host_0, {}, {}, []);
exports.AdvUserMessagesComponentNgFactory = AdvUserMessagesComponentNgFactory;
